import { Component, ChangeDetectionStrategy, ViewEncapsulation, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'tr-player-progress-bar',
    template: `<div (mouseup)="seek($event)" class='tr-player-progress-bar' #barElement>
        <span class='progress' [style.width.%]='completedPercent'></span>
    </div>`,
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    styleUrls: ['./tr-player-progress-bar.component.scss'],
})
export class TrPlayerProgressBarComponent {

    @Input() public completedPercent: number;
    @Input() public maxUserTimingPercent: number;
    @Output() public onBarClick: EventEmitter<number> = new EventEmitter();
    @Output() public onClientSeek: EventEmitter<number> = new EventEmitter<number>();
    @ViewChild('barElement', {static: true}) public barElement: ElementRef;

    public seek(event) {
        const elementWidht = this.barElement.nativeElement.clientWidth;
        const percentual = event.clientX * 100 / this.barElement.nativeElement.clientWidth;
        this.onClientSeek.emit(percentual > this.maxUserTimingPercent ? this.maxUserTimingPercent : percentual);
    }
}
